<ng-content></ng-content>

@if (context?.showActiveChevron) {
    <span divisor></span>
    <i  class="pi pi-chevron-{{active || context?.active ? 'up' : 'down'}}"></i>
}
